module.exports = __webpack_public_path__ + "static/img/double-ramp-8m-x-2m_256.a6592a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-ramp-8m-x-2m_256.png
// module id = MPVI
// module chunks = 0